import _ from 'lodash';
import set from 'lodash/fp/set';
import moment from 'moment';

export default function(state, action) {
    if (!state) {
        state = {
            answers: {},
            errors: {}
        };
    }

    let previous = state;
    switch (action.type) {
        case 'FORM_CREATE_RESPONSE':
            state = Object.assign({}, state, {
                UID: action.answerUID,
                formId: action.formId,
                eventId: action.eventId,
                createdAt: moment().toISOString(),
                hasData: false
            });
            break;
        case 'FORM_SET_ANSWER_VALUE':
            state = set(
                `answers.${action.questionId}`, _.isArray(action.value)
                ? action.value
                : [action.value],
            state);
            break;
    }

    // Update validation
    if ((previous.answers != state.answers || action.forceRevalidation) && action.metadata) {
        state.errors = _(action.metadata.groups || [])
            .map(group => group.questions)
            .flatten()
            .reduce((errors, question, i) => {
                // console.log('Q> ', question);
                if (question.required && !(state.answers[question.id] || []).map(value => value.toString().trim()).join('').length) {
                    errors[question.id] = 'required';
                } else if (question.type == 'options' && _(state).get(`answers[${question.id}]`, []).length < question.min_options) {
                    errors[question.id] = 'min_options';
                } else if (question.type == 'options' && _(state).get(`answers[${question.id}]`, []).length > question.max_options) {
                    errors[question.id] = 'max_options';
                }
                return errors;
            }, {});
    }

    // Other checks
    if (previous != state) {
        state.hasData = !!_(state.answers)
            .values()
            .flatten()
            .compact()
            .value()
            .length;
    }

    return state;
}
